import * as clipboard from 'clipboard-polyfill'
import {Lang} from 'yougile-lang'
import {Listener, logger} from 'yougile-util'
import {Backend} from '../../common/backend'
import {MessageBox} from '../components/message-box'
import {globals} from '../extensions/globals-base'

export class CompanyLink {
  private static link: string
  private static loaded = false

  public static listener = new Listener()

  public static get(): string {
    return CompanyLink.link
  }

  public static isLoaded(): boolean {
    return CompanyLink.loaded
  }

  public static load(): void {
    if (globals.standalone) {
      return
    }
    void Backend.getJSON('/data/company-links', {
      data: {
        ...Backend.loadCred(),
        companyId: globals.getCompanyId()
      }
    }).then((res: any) => {
      CompanyLink.loaded = true
      CompanyLink.link = res.link
      void CompanyLink.listener.trigger()
    })
  }

  public static copy(): void {
    if (!CompanyLink.link) {
      return
    }
    clipboard
      .writeText(`https://${CompanyLink.link}.yougile.com`)
      .then(() => MessageBox.show(Lang.msg.permission.regLinkCopied, 'success'))
      .catch(e => logger.log('err', e))
  }

  public static change(newValue: string): Promise<{error?: string}> {
    return Backend.postJSON('/data/company-links', {
      ...Backend.loadCred(),
      companyId: globals.getCompanyId(),
      link: newValue.trim().toLowerCase()
    })
      .then((res: any) => {
        if (res.result === 'ok') {
          CompanyLink.load()
          return {}
        } else {
          return {error: 'ERROR'}
        }
      })
      .catch(error => ({error}))
  }
}
